import React from "react";
import { Box, Typography, Paper, Grid, Button } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';
import {
  harmonatePageSx,
  harmonatePageTitleSx,
  harmonateCardSx,
  harmonateProceedButtonSx,
  harmonateUploadOutlinedSx,
  harmonateSectionTitleSx,
} from '../../../theme/harmonateStyles';

const Dispute = ({ onBack, caseData = {} }) => {
  return (
    <Box sx={{ ...harmonatePageSx, height: '100vh', overflow: 'auto' }}>
      {/* Header with Back Button */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          sx={harmonateUploadOutlinedSx}
        >
          Back to Case
        </Button>
        <Typography variant="h6" sx={harmonatePageTitleSx}>
          Chargeback Dispute Filing Letter
        </Typography>
      </Box>

      {/* Case Information */}
      <Paper sx={{ ...harmonateCardSx, bgcolor: ht.white, p: 3, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">Case Number</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.caseNumber || 'N/A'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">Status</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.status || 'N/A'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">Processed Date</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.processedDate || 'N/A'}</Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">Recommended Deadline</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.recommendedDeadline || 'N/A'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">MID</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.mid || 'N/A'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2" color="textSecondary">MID Alias</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{caseData.midAlias || 'N/A'}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Dispute Letter */}
      <Paper sx={{ ...harmonateCardSx, bgcolor: ht.white, p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ ...harmonateSectionTitleSx, mb: 2 }}>Dispute Letter</Typography>
        <Typography variant="body1" paragraph>
          This letter serves as formal notification of our dispute regarding the chargeback for the above-referenced transaction.
        </Typography>
        
        <Typography variant="body1" paragraph>
          We believe this chargeback is invalid for the following reasons:
        </Typography>
        
        <Typography variant="body1" component="div" sx={{ pl: 2, mb: 2 }}>
          <ol>
            <li>The transaction was properly authorized and completed.</li>
            <li>The customer received the goods/services as described.</li>
            <li>All terms of service were clearly communicated and agreed upon.</li>
          </ol>
        </Typography>
        
        <Typography variant="body1" paragraph>
          We have attached all relevant documentation to support our position, including:
        </Typography>
        
        <Typography variant="body1" component="div" sx={{ pl: 2, mb: 2 }}>
          <ul>
            <li>Proof of delivery/service</li>
            <li>Transaction authorization records</li>
            <li>Customer communication history</li>
            <li>Any additional supporting documents</li>
          </ul>
        </Typography>
        
        <Typography variant="body1" paragraph>
          We respectfully request that this chargeback be reversed and the funds be returned to our account. Please let us know if you require any additional information to process this dispute.
        </Typography>
        
        <Box sx={{ mt: 4, mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>Sincerely,</Typography>
          <Box sx={{ height: '1px', width: '200px', bgcolor: ht.text, my: 2 }} />
          <Typography variant="body1">Your Name</Typography>
          <Typography variant="body2" color="text.secondary">Dispute Resolution Department</Typography>
        </Box>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          variant="contained"
          onClick={onBack}
          sx={harmonateProceedButtonSx}
        >
          Back to Case
        </Button>
      </Box>
    </Box>
  );
};

export default Dispute;
